<template>
  <a-date-picker
    mode="year"
    :open="isOpen"
    v-bind="$attrs"
    :value="value"
    format="YYYY"
    @panelChange="handlePanelChange"
    @openChange="isOpen = $event"
    @change="$emit('change', null)"
  ></a-date-picker>
</template>

<script>
export default {
  name: 'AYearPicker',
  props: ['value'],
  data () {
    return {
      isOpen: false
    }
  },
  methods: {
    handlePanelChange (event) {
      this.isOpen = false
      this.$emit('change', event)
    }
  }
}
</script>
